import fs from 'node:fs'
import path from 'node:path'

/**
 * A project created by `vercel projects add` keeps Framework Preset "Other", so the build ignores
 * the Next.js output and every route 404s. A `vercel.json` fixes the preset per deployment.
 */
export function ensureVercelJsonFramework(cwd: string): 'created' | 'exists' {
  const vercelJsonPath = path.join(cwd, 'vercel.json')
  if (fs.existsSync(vercelJsonPath)) {
    return 'exists'
  }

  fs.writeFileSync(
    vercelJsonPath,
    `${JSON.stringify({ $schema: 'https://openapi.vercel.sh/vercel.json', framework: 'nextjs' }, null, 2)}\n`,
    'utf-8'
  )
  return 'created'
}
